import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { TranslateModule } from '@ngx-translate/core';
import { MealPlanService } from '@services/meal-plan.service';
import { LoaderComponent } from '@components/app-loader/app-loader.component';

export type OrderMode = 'meal_plan' | 'by_course';

@Component({
  selector: 'app-choose-order-type-page',
  imports: [TranslateModule, LoaderComponent],
  templateUrl: './choose-order-type-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'block h-full',
  },
})
export class ChooseOrderTypePageComponent {
  private readonly router = inject(Router);
  private readonly mealPlanService = inject(MealPlanService);

  readonly loadingMode = signal<OrderMode | null>(null);

  selectMode(mode: OrderMode): void {
    if (mode === 'by_course') {
      this.mealPlanService.clearMealPlan();
    }

    this.loadingMode.set(mode);
    void this.router
      .navigate([
        mode === 'meal_plan' ? AppRoutes.chooseMealPlan : AppRoutes.order,
      ])
      .finally(() => this.loadingMode.set(null));
  }
}
